<div fxLayout="row" fxLayoutAlign="center center" class="error-page-wrap">
  <mat-card class="error-card">

    <div class="error-hero" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <mat-icon class="error-hero-icon">travel_explore</mat-icon>
      </div>
      <div class="error-hero-divider"></div>
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <h1 class="error-code">404</h1>
        <div class="error-status">{{ 'page-not-found' | translate }}</div>
      </div>
    </div>

    <mat-card-content class="error-body" fxLayout="column" fxLayoutAlign="center center">
      <p class="error-message">{{ 'not-found-page' | translate }}</p>
      <mat-form-field appearance="outline" class="w-100 search-field">
        <mat-label>{{ 'search-keyword' | translate }}</mat-label>
        <input matInput [placeholder]="'search-keyword-placeholder' | translate" [(ngModel)]="routerLink" (keyup.enter)="searchForRoute()" />
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <div class="error-actions" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="16px">
        <button mat-stroked-button class="btn-outline-dark" type="button" (click)="goHome()">
          <mat-icon>home</mat-icon>
          {{ 'go-home' | translate }}
        </button>
        <button mat-stroked-button type="button" (click)="searchForRoute()">
          <mat-icon>search</mat-icon>
          {{ 'search' | translate }}
        </button>
      </div>
    </mat-card-content>

  </mat-card>
</div>
